import { lazy } from 'react'

const SignInPage = lazy(() => import('../features/auth/pages/SignInPage'))
const SignUpPage = lazy(() => import('../features/auth/pages/SignUpPage'))
const ComingSoonPage = lazy(() => import('../app/pages/ComingSoonPage'))

export const publicRoutes = [
  { path: '/sign-in/*', element: <SignInPage /> },
  { path: '/sign-up/*', element: <SignUpPage /> },
  { path: '/reset-password', element: <ComingSoonPage /> },
]
